import { useMemo } from "react"
import { useLocation } from "react-router-dom"

interface PageContext {
  orderId: number | null
  projectId: number | null
  path: string
}

export function usePageContext(): PageContext {
  const location = useLocation()

  return useMemo(() => {
    const path = location.pathname

    // Match /orders/:id
    const orderMatch = path.match(/^\/orders\/(\d+)/)
    const orderId = orderMatch ? Number(orderMatch[1]) : null

    // Match /projects/:id
    const projectMatch = path.match(/^\/projects\/(\d+)/)
    const projectId = projectMatch ? Number(projectMatch[1]) : null

    return { orderId, projectId, path }
  }, [location.pathname])
}
